export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";